/** Shared by ProfessionalJoinWizard (pre-signup) and ProfessionalDashboard (profile). */

/** Business email from /for-professionals CTA; survives Stripe redirect (full page reload). */
export const PRO_LANDING_INTEREST_EMAIL_KEY = 'proLandingInterestEmail';

/** Owner-sent pro invite link (`/professional?proInvite=…`); survives navigation into join wizard. */
export const OWNER_PRO_INVITE_TOKEN_KEY = 'td_owner_pro_invite';

export const REPAIR_CATEGORIES = [
  'Plumbing', 'Electrical', 'Heating/Cooling', 'Roofing', 'Flooring',
  'Painting', 'Drywall', 'Appliances', 'Windows/Doors', 'General Maintenance (Handyman)',
  'Pest Control', 'Landscaping', 'Cleaning', 'Other',
];

export const TRADE_META = {
  Plumbing: { icon: '🔧', requiresLicense: true, tradeType: 'licensed' },
  Electrical: { icon: '⚡', requiresLicense: true, tradeType: 'licensed' },
  'Heating/Cooling': { icon: '❄️', requiresLicense: true, tradeType: 'licensed' },
  Roofing: { icon: '🏠', requiresLicense: true, tradeType: 'licensed' },
  'Pest Control': { icon: '🐛', requiresLicense: true, tradeType: 'licensed' },
  'General Maintenance (Handyman)': { icon: '🛠️', requiresLicense: false, tradeType: 'handyman' },
  Painting: { icon: '🎨', requiresLicense: false, tradeType: 'general' },
  Drywall: { icon: '🧱', requiresLicense: false, tradeType: 'general' },
  Flooring: { icon: '🪵', requiresLicense: false, tradeType: 'general' },
  Appliances: { icon: '🔌', requiresLicense: false, tradeType: 'general' },
  'Windows/Doors': { icon: '🪟', requiresLicense: false, tradeType: 'general' },
  Landscaping: { icon: '🌿', requiresLicense: false, tradeType: 'general' },
  Cleaning: { icon: '🧹', requiresLicense: false, tradeType: 'general' },
  Other: { icon: '📦', requiresLicense: false, tradeType: 'general' },
};

/** Public join flow — narrative labels (vetting before account). */
export const JOIN_ONBOARDING_STEPS = [
  { num: 1, label: 'Your trades', kicker: 'Start here' },
  { num: 2, label: 'Credentials', kicker: 'Trust' },
  { num: 3, label: 'Your turf', kicker: 'Coverage' },
  { num: 4, label: 'Unlock', kicker: 'Deposit' },
  { num: 5, label: 'Your account', kicker: 'Go live' },
];

export const YEARS_OPTIONS = ['Less than 1 year', '1–3 years', '3–5 years', '5–10 years', '10+ years'];

export const PRO_DEPOSIT_AMOUNT = 20;
